import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import NestedCheckboxList from '../NestedCheckboxList'
import { toggleSelection } from '../../actions/formActions'
import SelectedValue from '../SelectedValue'

const DepartureList = ({
    departures,
    selectedDepartures,
    toggleSelection
}) => {
    const { t } = useTranslation()

    const selectItemHandler = (field, nextSelected) => {
        toggleSelection(field, nextSelected)
    }

    return (
        <div className="trip-modal__columns trip-modal__columns--2">
            <div className="trip-modal__col trip-modal__col--order-mobile-2">
                <h4 className="trip-modal__title trip-modal__title--small">
                    {t('modal.departures.section_placeholder')}
                </h4>
                <NestedCheckboxList
                    field="z"
                    uniquePrefix='dep'
                    data={departures}
                    selected={selectedDepartures || ''}
                    onChange={selectItemHandler}
                />
            </div>
            <div className="trip-modal__col trip-modal__col--order-mobile-1">
                <SelectedValue
                    header={t('common.selected_header')}
                    selectedValues={selectedDepartures}
                    field="z"
                    onRemove={selectItemHandler}
                />
            </div>
        </div>
    )
}

DepartureList.propTypes = {
    departures: PropTypes.array,
    selectedDepartures: PropTypes.string,
    toggleSelection: PropTypes.func
}

const mapStateToProps = (state) => ({
    selectedDepartures: state.formReducer.z
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            toggleSelection
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(DepartureList)
